import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Platform } from 'react-native';
import urls from '../../utils/urls';
import useNotify from '../useNotify';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';

const intl = getIntl('useFastenReconnect', {
    errorReconnecting: 'Error reconnecting to Fasten Health',
});

export type UseFastenReconnectArgs = {
    medicalProfileId: string;
    orgConnectionId: string;
    onReconnectUrlReceived: (redirectUrl: string) => void;
};

export default function useFastenReconnect({
    medicalProfileId,
    orgConnectionId,
    onReconnectUrlReceived,
}: UseFastenReconnectArgs) {
    const notify = useNotify();
    const [isRedirecting, setIsRedirecting] = useState(false);

    const reconnectMutation = useMutation({
        mutationFn: async () => {
            const response = await appAPI.post<{ redirectUrl: string }>(
                urls.api.ehrIntegrations.fasten.endpoints.reconnect(medicalProfileId, orgConnectionId),
                { body: {} },
            );
            if (Platform.OS === 'web') setIsRedirecting(true);
            onReconnectUrlReceived(response.redirectUrl);
        },
        onError: () => {
            notify('error', intl('errorReconnecting'));
        },
    });

    return {
        reconnect: reconnectMutation.mutate,
        isReconnecting: reconnectMutation.isPending || isRedirecting,
    };
}
